import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withToolsSiteMap,
  siteMapPropType,
  processor,
} from '@bingads-webui-campaign-react/with-site-map';
import { PageMenu } from '@bingads-webui-campaign-react/page-menu';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { AssetLibraryIcon } from '@bingads-webui-theme-2018/embeded-svgs';

const ASSETS_LIBRARY_ROOT_ID = 'creative-studio-asset-library';
const ASSETS_MENU_ID = 'creative-studio-asset-library';
const PERFORMANCE_MENU_ID = 'creative-studio-asset-library-performance';

const assetLibraryPageGroups = [
  [ASSETS_MENU_ID],
  [PERFORMANCE_MENU_ID],
];

export const Loader = (props) => {
  const {
    siteMap, updateAvailability, mode, ...rest
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  const renderItemIcon = ({ id }) => {
    if (id === PERFORMANCE_MENU_ID) {
      return <Glyphicon glyph="ba-Chart" />;
    }
    if (id === ASSETS_MENU_ID) {
      return (
        <div style={{ position: 'relative', top: 2 }}>
          <AssetLibraryIcon />
        </div>
      );
    }
    return null;
  };

  const { children: assetLibrarySiteMap = [] } = selectedParent || {};
  return props.isVisible
    ? <PageMenu
        pageGroups={assetLibraryPageGroups}
        siteMap={assetLibrarySiteMap}
        renderItemIcon={renderItemIcon}
        collapsed={mode === 'collapsed'}
        {...rest}
    />
    : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
    }),
  }).isRequired,
  mode: PropTypes.string,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  isVisible: false,
  mode: undefined,
};

const processors = [processor.processPermissions, processor.processPath, processor.processScope];

export const AssetLibraryPageMenuLoader = withToolsSiteMap(
  React.memo(Loader),
  processors,
  [ASSETS_LIBRARY_ROOT_ID]
);
